export function handleDisconnectTrack(track) {
  if (!track) return;

  const attachedElements = track.detach();
  attachedElements.forEach(element => element.remove());
}

export function handleDisconnectParticipant(participant) {
  const audioPublications = Array.from(participant.audioTracks.values());
  const videoPublications = Array.from(participant.videoTracks.values());
  audioPublications.forEach(publication => handleDisconnectTrack(publication.track));
  videoPublications.forEach(publication => handleDisconnectTrack(publication.track));
}

export function handleDisconnectRoom(room) {
  handleDisconnectParticipant(room.localParticipant);
  Array.from(room.participants.values()).forEach(p => handleDisconnectParticipant(p));
}
